import React from 'react';
import { Box, CircularProgress, circularProgressClasses, CircularProgressProps } from '@mui/material';

export const CircleProgress = (props: CircularProgressProps) => {
  return (
    <Box sx={{ position: 'relative' }}>
      <CircularProgress
        {...props}
        sx={{
          color: (theme) => theme.palette.primary[50],
        }}
        value={100}
        variant="determinate"
      />
      <CircularProgress
        sx={{
          color: (theme) => (theme.palette.mode === 'dark' ? theme.palette.primary[200] : theme.palette.primary[600]),
          animationDuration: '550ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        {...props}
      />
    </Box>
  );
};
